/*
 * @Author: Roman
 * @Date: 2022-12-13 18:37:57
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2022-12-15 17:43:05
 * @FilePath: \qpmn-site\src\app\modules\user\rest\anonymous-user-rest.service.ts
 * @Description: 
 */
/**
 * @description 匿名用户 RestService
 * @deprecated
 */
export class AnonymousUserRestService implements qpmn.user.rest.IAnonymousUserRestService {

    public static readonly $inject: string[] = ["$rest"];

    constructor(private $rest: qpmn.common.rest.IRestService) { }

    /**
     * @description 匿名用户登录
     * 匿名用户登录采用网站环境配置中的账号信息进行登录,因此在这里不需要额外传入参数
     * 若没有匿名用户id则传入 anonymousUserId: 0 用于创建匿名用户
     * @returns 
     */
    public login(anonymousUserId: number): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.user.model.domain.IAnonymousUser>> {
        return this.$rest.http<qpmn.user.model.domain.IAnonymousUser>("anonymousUserRestService", "login", {
            anonymousUserId: anonymousUserId
        });
    }
}